/**
 * Sensible Shoes: you move faster. That is the whole perk.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const SENSIBLE_SHOES = {
  id: 'sensibleShoes',
  branch: 'survival',
  tier: 1,
  title: 'Sensible Shoes',
  blurb: 'Rated for factory floors, evacuation routes and the ground between them.',
  maxRanks: 3,
  minLevel: 3,
  requires: [],
  statGrants: {},
  effects: [{ field: 'moveSpeed', perRank: 0.04, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
